import { Injectable } from "@angular/core";
import {Action, Selector, State, StateContext, StateToken, Store} from "@ngxs/store";
import { CicdFactorisationsService } from "./cicd-factorisations.service";
import {
  ClearCicdFactorisationsRepository,
  LoadCicdFactorisationsData,
  SetCicdFactorisationsRepository,
  SetCicdFactorisationMode
} from "./cicd-factorisations.actions";
import { tap } from "rxjs";
import { CicdFactorisationsStateModel } from "./cicd-factorisations.model";
import { FactorisationModeEnum } from "src/app/shared/enum/factorisation-mode.enum";
import { MetaService } from "src/app/store/meta/meta.service";
import { MetaRequestHelper } from "src/app/store/meta/meta-request.helper";

export const CICD_FACTORISATIPONS_TOKEN: StateToken<CicdFactorisationsStateModel> = new StateToken('cicdFactorisations');

const CicdFactorisationsStateModelDefault: CicdFactorisationsStateModel = {
  repositories: [],
  factorisationMode: FactorisationModeEnum.USAGE,
  selectedRepository: {
    id: "",
    name: "",
    url: "",
    age: 0,
    state: 'ignored',
    full_path: "",
    "cicd-docker-images": [],
    "cicd-libraries": [],
    "cicd-templates": [],
    docker_images_repos: [],
    archived: false,
    type: ""
  }
}

@State<CicdFactorisationsStateModel>({
    name: CICD_FACTORISATIPONS_TOKEN,
    defaults: CicdFactorisationsStateModelDefault
})
@Injectable()
export class CicdFactorisationsState {

    private readonly KEY = CICD_FACTORISATIPONS_TOKEN.getName()

    constructor(
        private cicdFactorisationsService: CicdFactorisationsService,
        private metaService: MetaService,
        private store: Store,
    ) {
    }

    @Selector([CICD_FACTORISATIPONS_TOKEN])
    static getRepositories(state: CicdFactorisationsStateModel) {
        return state.repositories
    }

    @Selector([CICD_FACTORISATIPONS_TOKEN])
    static getFactorisationMode(state: CicdFactorisationsStateModel) {
        return state.factorisationMode
    }

    @Selector([CICD_FACTORISATIPONS_TOKEN])
    static getSelectedRepository(state: CicdFactorisationsStateModel) {
        return state.selectedRepository
    }

    @Action(LoadCicdFactorisationsData)
    loadCicdFactorisationsData(ctx: StateContext<CicdFactorisationsStateModel>) {
        const FACTORISATION_DATA_KEY = this.KEY + "-" + LoadCicdFactorisationsData.name

        if(!this.metaService.isStale(FACTORISATION_DATA_KEY)) return

        return MetaRequestHelper.wrapRequest(
            this.store,
            FACTORISATION_DATA_KEY,
            this.cicdFactorisationsService.loadCicdFactorisationsData(),
            payload => {
                ctx.patchState(
                    {
                        repositories: payload
                    }
                )
            }
        )
    }

    @Action(SetCicdFactorisationMode)
    setCicdFactorisationMode(ctx: StateContext<CicdFactorisationsStateModel>, payload: any){
        return ctx.patchState({
            factorisationMode: payload.payload
        })
    }

    @Action(ClearCicdFactorisationsRepository)
    clearCicdFactorisationsRepository(ctx: StateContext<CicdFactorisationsStateModel>){
        return ctx.patchState({
            selectedRepository: CicdFactorisationsStateModelDefault.selectedRepository
        })
    }

    @Action(SetCicdFactorisationsRepository)
    setCicdFactorisationsRepository(ctx: StateContext<CicdFactorisationsStateModel>, payload: any){
        const state = ctx.getState()
        state.repositories.forEach(repository => {
            if (repository.full_path == payload.payload) {
                ctx.patchState({
                    selectedRepository: repository
                })
            }
        })
    }
}
